module.exports = __webpack_public_path__ + "@/assets/img/MA-5000-gray.f4d85636.jpg";